'use client';

import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';
import type { SiteSettingsDto } from '@/lib/sanity/dto';

const SiteSettingsContext = createContext<SiteSettingsDto | null>(null);

export function SiteSettingsProvider({
    settings,
    children,
}: {
    settings: SiteSettingsDto | null;
    children: ReactNode;
}) {
    return <SiteSettingsContext.Provider value={settings}>{children}</SiteSettingsContext.Provider>;
}

export function useSiteSettings() {
    const ctx = useContext(SiteSettingsContext);
    if (!ctx) {
        throw new Error('useSiteSettings must be used within SiteSettingsProvider');
    }
    return ctx;
}
